import { Icon } from '../components/Icon.js';

/** Shared pieces of the admin tables: debounced search and a pager. */

export const PAGE_SIZE = 25;

export function SearchBox({
  value,
  onChange,
  placeholder,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}) {
  return (
    <div className="input-group admin-search">
      <Icon name="search" size={15} />
      <input
        className="input"
        type="search"
        value={value}
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
}

export function Pager({
  offset,
  total,
  onChange,
}: {
  offset: number;
  total: number;
  onChange: (offset: number) => void;
}) {
  const from = total === 0 ? 0 : offset + 1;
  const to = Math.min(offset + PAGE_SIZE, total);

  return (
    <div className="pager">
      <span className="muted small">
        {from}–{to} of {total}
      </span>
      <button
        type="button"
        className="btn btn--icon btn--sm"
        aria-label="Previous page"
        disabled={offset === 0}
        onClick={() => onChange(Math.max(0, offset - PAGE_SIZE))}
      >
        <Icon name="chevronLeft" size={15} />
      </button>
      <button
        type="button"
        className="btn btn--icon btn--sm"
        aria-label="Next page"
        disabled={to >= total}
        onClick={() => onChange(offset + PAGE_SIZE)}
      >
        <Icon name="chevronRight" size={15} />
      </button>
    </div>
  );
}
